var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLodging(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 13.3337C13.3346 13.7019 13.0362 14.0004 12.668 14.0004H3.33464C2.96645 14.0004 2.66797 13.7019 2.66797 13.3337V7.33374H0.667969L7.55284 1.07474C7.8071 0.843576 8.1955 0.843576 8.44977 1.07474L15.3346 7.33374H13.3346V13.3337ZM7.33464 8.66708V12.6671H8.66797V8.66708H7.33464Z",
    fill: "#8CA2FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLodging);
export default __webpack_public_path__ + "static/media/icon_lodging.b1a02061fad7d66b4decdafaa0cdf431.svg";
export { ForwardRef as ReactComponent };